/**
 * @flow
 * @relayHash b66d61f86a8579dc941e057f708fb9e5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type StockOrderDetails_stockOrder$ref = any;
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
export type FeeType = "ADE" | "ADF" | "ASB" | "AVH" | "BUF" | "CHI" | "CHIP" | "CHUP" | "CON" | "COR" | "CRDT" | "FXB" | "GST" | "INT" | "MGN" | "MSB" | "PLF" | "PLT" | "PRO" | "RTA" | "RTP" | "SIPP" | "STB" | "STBV" | "TAX" | "TRA" | "VHF" | "WDR" | "%future added value";
export type OrderStatus = "CAN" | "CRE" | "FIL" | "INI" | "INM" | "PEX" | "PFL" | "POS" | "QUE" | "REJ" | "%future added value";
export type OrderType = "LMT" | "MKT" | "SLMT" | "SMKT" | "TLMT" | "TMKT" | "%future added value";
export type PortfolioOrderSide = "BUY" | "REB" | "SELL" | "%future added value";
export type PortfolioOrderStatus = "CAN" | "COM" | "CRE" | "FIL" | "PEX" | "PFL" | "PRO" | "REJ" | "%future added value";
export type ReportState = "ERR" | "FIN" | "REQ" | "%future added value";
export type Side = "BUY" | "SELL" | "%future added value";
export type BulkOrderViewQueryVariables = {|
  bulkOrderId: string
|};
export type BulkOrderViewQueryResponse = {|
  +viewer: ?{|
    +bulkOrders: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +createdBy: ?{|
            +id: string,
            +fullName: ?string,
          |},
          +portfolioorderSet: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +side: PortfolioOrderSide,
                +createdAt: any,
                +updatedAt: any,
                +status: PortfolioOrderStatus,
                +bulkOrder: ?{|
                  +id: string
                |},
                +portfolio: {|
                  +id: string,
                  +trackingVueName: ?string,
                  +trackingVue: ?{|
                    +id: string,
                    +name: string,
                  |},
                |},
                +account: {|
                  +id: string,
                  +name: ?string,
                |},
                +tradeInvoice: ?{|
                  +pdf: ?string,
                  +pdfUrl: ?string,
                  +createdAt: any,
                  +updatedAt: any,
                  +state: ReportState,
                |},
                +stockOrders: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +$fragmentRefs: StockOrderDetails_stockOrder$ref
                    |}
                  |}>
                |},
              |}
            |}>
          |},
          +fxorderSet: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +price: ?number,
                +quantity: ?number,
                +createdAt: any,
                +updatedAt: any,
                +quantityToDate: ?number,
                +contract: {|
                  +id: string,
                  +currency: Currency,
                  +symbol: string,
                  +localSymbol: string,
                  +ibConId: any,
                |},
                +orderPtr: {|
                  +account: {|
                    +id: string,
                    +name: ?string,
                  |},
                  +orderType: OrderType,
                  +executionSet: {|
                    +edges: $ReadOnlyArray<?{|
                      +node: ?{|
                        +id: string,
                        +transaction: ?{|
                          +id: string
                        |},
                        +price: number,
                        +proceeds: ?number,
                        +executionDatetime: any,
                        +quantity: number,
                        +currency: Currency,
                      |}
                    |}>
                  |},
                  +transactions: {|
                    +edges: $ReadOnlyArray<?{|
                      +node: ?{|
                        +id: string,
                        +commission: ?number,
                        +tax: ?number,
                        +transactionaccountchargeSet: {|
                          +edges: $ReadOnlyArray<?{|
                            +node: ?{|
                              +id: string,
                              +amount: number,
                              +currency: Currency,
                              +feeType: FeeType,
                              +accountchargePtr: {|
                                +id: string,
                                +amount: number,
                                +currency: Currency,
                                +accountchargetenantportionSet: {|
                                  +edges: $ReadOnlyArray<?{|
                                    +node: ?{|
                                      +id: string,
                                      +quantity: number,
                                      +tenant: ?{|
                                        +name: string,
                                        +id: string,
                                      |},
                                    |}
                                  |}>
                                |},
                              |},
                            |}
                          |}>
                        |},
                      |}
                    |}>
                  |},
                |},
                +brokerOrder: ?{|
                  +id: string,
                  +twsOrderId: ?number,
                  +twsPermId: ?number,
                  +cashQuantity: ?number,
                  +quantityFilled: ?number,
                  +quantityLeft: ?number,
                  +stopPrice: ?number,
                  +trailStopRatio: ?number,
                  +trailStopOffset: ?number,
                  +lastSyncTime: ?any,
                  +status: OrderStatus,
                  +orderRef: ?string,
                  +side: Side,
                  +orderType: OrderType,
                  +ibExchange: ?{|
                    +id: string,
                    +symbol: string,
                  |},
                  +brokerorderamendmentSet: {|
                    +edges: $ReadOnlyArray<?{|
                      +node: ?{|
                        +id: string,
                        +quantity: number,
                        +previousQuantity: number,
                        +previousLimitPrice: ?number,
                        +limitPrice: ?number,
                        +amendmentRef: ?string,
                      |}
                    |}>
                  |},
                |},
              |}
            |}>
          |},
        |}
      |}>
    |},
    +exchanges: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +symbol: string,
          +nextDaySession: ?{|
            +startTime: ?any,
            +endTime: ?any,
          |},
        |}
      |}>
    |},
  |}
|};
export type BulkOrderViewQuery = {|
  variables: BulkOrderViewQueryVariables,
  response: BulkOrderViewQueryResponse,
|};
*/


/*
query BulkOrderViewQuery(
  $bulkOrderId: ID!
) {
  viewer {
    bulkOrders(id: $bulkOrderId) {
      edges {
        node {
          id
          createdBy {
            id
            fullName
          }
          portfolioorderSet {
            edges {
              node {
                id
                side
                createdAt
                updatedAt
                status
                bulkOrder {
                  id
                }
                portfolio {
                  id
                  trackingVueName
                  trackingVue {
                    id
                    name
                  }
                }
                account {
                  id
                  name
                }
                tradeInvoice {
                  pdf
                  pdfUrl
                  createdAt
                  updatedAt
                  state
                  id
                }
                stockOrders(orderBy: "createdAt") {
                  edges {
                    node {
                      ...StockOrderDetails_stockOrder
                      id
                    }
                  }
                }
              }
            }
          }
          fxorderSet {
            edges {
              node {
                id
                price
                quantity
                createdAt
                updatedAt
                quantityToDate
                contract {
                  id
                  currency
                  symbol
                  localSymbol
                  ibConId
                }
                orderPtr {
                  account {
                    id
                    name
                  }
                  orderType
                  executionSet {
                    edges {
                      node {
                        id
                        transaction {
                          id
                        }
                        price
                        proceeds
                        executionDatetime
                        quantity
                        currency
                      }
                    }
                  }
                  transactions {
                    edges {
                      node {
                        id
                        commission
                        tax
                        transactionaccountchargeSet {
                          edges {
                            node {
                              id
                              amount
                              currency
                              feeType
                              accountchargePtr {
                                id
                                amount
                                currency
                                accountchargetenantportionSet {
                                  edges {
                                    node {
                                      id
                                      quantity
                                      tenant {
                                        name
                                        id
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  id
                }
                brokerOrder {
                  id
                  twsOrderId
                  twsPermId
                  cashQuantity
                  quantityFilled
                  quantityLeft
                  stopPrice
                  trailStopRatio
                  trailStopOffset
                  lastSyncTime
                  status
                  orderRef
                  side
                  orderType
                  ibExchange {
                    id
                    symbol
                  }
                  brokerorderamendmentSet {
                    edges {
                      node {
                        id
                        quantity
                        previousQuantity
                        previousLimitPrice
                        limitPrice
                        amendmentRef
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    exchanges {
      edges {
        node {
          symbol
          nextDaySession {
            startTime
            endTime
          }
          id
        }
      }
    }
    id
  }
}

fragment StockOrderDetails_stockOrder on StockOrderNode {
  parentOrder {
    id
  }
  id
  orderRef
  status
  pendingStatus
  price
  quantity
  cashQuantity
  side
  createdAt
  updatedAt
  orderType
  quantityToDate
  executedQuantityToDate
  matched
  blockedHoldings
  blockedProceeds
  blockedBaseCharges
  blockedLocalCharges
  customCommission
  advancedOrderType
  actionLogs(orderBy: "actionTime") {
    edges {
      node {
        actionId
        actionType
        actionTime
        actionDescription
        user {
          fullName
          id
        }
        id
      }
    }
  }
  contract {
    id
    currency
    symbol
    name
    industry
    ibConId
    instrumentType
    exchange {
      name
      symbol
      id
    }
  }
  account {
    id
    name
    clientaccount {
      id
      accountType
    }
  }
  portfolioOrder {
    id
  }
  executionSet {
    edges {
      node {
        transaction {
          id
        }
        price
        proceeds
        executionDatetime
        quantity
        currency
        id
      }
    }
  }
  proceedsToDate
  proceedsToDateBase
  brokerOrder {
    id
    twsOrderId
    twsPermId
    cashQuantity
    quantityFilled
    quantityLeft
    stopPrice
    trailStopRatio
    trailStopOffset
    lastSyncTime
    status
    orderRef
    ackedClientOrderId
    brokerSideOrderId
    ibExchange {
      id
      symbol
    }
    algoParams {
      algo
      orderalgoparamstwap {
        strategyType
        startTime
        endTime
        allowPastEndTime
        id
      }
      orderalgoparamsvwap {
        id
        maxVolumeRatio
        startTime
        endTime
        allowPastEndTime
        neverTakeLiquidity
        speedup
      }
      id
    }
    brokerorderamendmentSet(orderBy: "sequence") {
      edges {
        node {
          id
          limitPrice
          previousLimitPrice
          quantity
          previousQuantity
          status
          blockingRevised
          createdAt
          updatedAt
        }
      }
    }
  }
  orderPtr {
    orderapprovalcontractSet {
      edges {
        node {
          id
          approval {
            id
            portfolioOrder {
              id
              status
            }
            createdAt
            updatedAt
            approvedAt
            notifiedAt
            remindedAt
            proposal {
              id
              type
            }
            rationaleUrl
            approvedBy {
              fullName
              id
            }
            status
            portfolio {
              id
              trackingVueName
              account {
                name
                id
              }
            }
            actionLogs {
              edges {
                node {
                  id
                  actionDescription
                  actionId
                  actionTime
                  actionType
                  user {
                    id
                    fullName
                  }
                }
              }
            }
          }
        }
      }
    }
    id
  }
  tradeInvoice {
    id
    pdfUrl
    pdf
    state
    createdAt
    updatedAt
    portfolioOrder {
      id
    }
  }
  transactions {
    edges {
      node {
        id
        commission
        tax
        transactionaccountchargeSet {
          edges {
            node {
              id
              amount
              currency
              feeType
              accountchargePtr {
                accountchargetenantportionSet {
                  edges {
                    node {
                      id
                      quantity
                      tenant {
                        name
                        id
                      }
                    }
                  }
                }
                id
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "bulkOrderId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "bulkOrderId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "createdBy",
  "storageKey": null,
  "args": null,
  "concreteType": "UserNode",
  "plural": false,
  "selections": (v4/*: any*/)
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "side",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updatedAt",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v10 = [
  (v2/*: any*/)
],
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "bulkOrder",
  "storageKey": null,
  "args": null,
  "concreteType": "BulkOrderNode",
  "plural": false,
  "selections": (v10/*: any*/)
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "trackingVueName",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v14 = [
  (v2/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolio",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v12/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "trackingVue",
      "storageKey": null,
      "args": null,
      "concreteType": "VueNode",
      "plural": false,
      "selections": (v14/*: any*/)
    }
  ]
},
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "account",
  "storageKey": null,
  "args": null,
  "concreteType": "AccountNode",
  "plural": false,
  "selections": (v14/*: any*/)
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pdf",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pdfUrl",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v20 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "createdAt"
  }
],
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantityToDate",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ibConId",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "contract",
  "storageKey": null,
  "args": null,
  "concreteType": "FxContractNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "localSymbol",
      "args": null,
      "storageKey": null
    },
    (v26/*: any*/)
  ]
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderType",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "transaction",
  "storageKey": null,
  "args": null,
  "concreteType": "TransactionNode",
  "plural": false,
  "selections": (v10/*: any*/)
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "proceeds",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "executionDatetime",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "executionSet",
  "storageKey": null,
  "args": null,
  "concreteType": "ExecutionNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ExecutionNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ExecutionNode",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v29/*: any*/),
            (v21/*: any*/),
            (v30/*: any*/),
            (v31/*: any*/),
            (v22/*: any*/),
            (v24/*: any*/)
          ]
        }
      ]
    }
  ]
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "commission",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tax",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "feeType",
  "args": null,
  "storageKey": null
},
v37 = [
  (v13/*: any*/),
  (v2/*: any*/)
],
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "accountchargetenantportionSet",
  "storageKey": null,
  "args": null,
  "concreteType": "AccountChargeTenantPortionNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "AccountChargeTenantPortionNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "AccountChargeTenantPortionNode",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v22/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "tenant",
              "storageKey": null,
              "args": null,
              "concreteType": "TenantNode",
              "plural": false,
              "selections": (v37/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v39 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "transactions",
  "storageKey": null,
  "args": null,
  "concreteType": "TransactionNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "TransactionNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TransactionNode",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v33/*: any*/),
            (v34/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "transactionaccountchargeSet",
              "storageKey": null,
              "args": null,
              "concreteType": "TransactionAccountChargeNodeConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TransactionAccountChargeNodeEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "TransactionAccountChargeNode",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/),
                        (v35/*: any*/),
                        (v24/*: any*/),
                        (v36/*: any*/),
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "accountchargePtr",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "AccountChargeNode",
                          "plural": false,
                          "selections": [
                            (v2/*: any*/),
                            (v35/*: any*/),
                            (v24/*: any*/),
                            (v38/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "twsOrderId",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "twsPermId",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cashQuantity",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantityFilled",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantityLeft",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "stopPrice",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "trailStopRatio",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "trailStopOffset",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastSyncTime",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderRef",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "ibExchange",
  "storageKey": null,
  "args": null,
  "concreteType": "IBExchangeNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v25/*: any*/)
  ]
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "previousQuantity",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "previousLimitPrice",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "limitPrice",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokerOrder",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerOrderNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v40/*: any*/),
    (v41/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/),
    (v9/*: any*/),
    (v49/*: any*/),
    (v6/*: any*/),
    (v28/*: any*/),
    (v50/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "brokerorderamendmentSet",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerOrderAmendmentNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerOrderAmendmentNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "BrokerOrderAmendmentNode",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v22/*: any*/),
                (v51/*: any*/),
                (v52/*: any*/),
                (v53/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amendmentRef",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "startTime",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "endTime",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "nextDaySession",
  "storageKey": null,
  "args": null,
  "concreteType": "ExchangeSessionType",
  "plural": false,
  "selections": [
    (v55/*: any*/),
    (v56/*: any*/)
  ]
},
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionId",
  "args": null,
  "storageKey": null
},
v59 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionType",
  "args": null,
  "storageKey": null
},
v60 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionTime",
  "args": null,
  "storageKey": null
},
v61 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionDescription",
  "args": null,
  "storageKey": null
},
v62 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v63 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolioOrder",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioOrderNode",
  "plural": false,
  "selections": (v10/*: any*/)
},
v64 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "allowPastEndTime",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BulkOrderViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "bulkOrders",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "BulkOrderNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BulkOrderNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BulkOrderNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "portfolioorderSet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioOrderNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfolioOrderNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfolioOrderNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v11/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "tradeInvoice",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TradeInvoiceNode",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v18/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v19/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "stockOrders",
                                    "storageKey": "stockOrders(orderBy:\"createdAt\")",
                                    "args": (v20/*: any*/),
                                    "concreteType": "StockOrderNodeConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "StockOrderNodeEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "StockOrderNode",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "FragmentSpread",
                                                "name": "StockOrderDetails_stockOrder",
                                                "args": null
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "fxorderSet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FxOrderNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FxOrderNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FxOrderNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v23/*: any*/),
                                  (v27/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "orderPtr",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderNode",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v28/*: any*/),
                                      (v32/*: any*/),
                                      (v39/*: any*/)
                                    ]
                                  },
                                  (v54/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "exchanges",
            "storageKey": null,
            "args": null,
            "concreteType": "ExchangeNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ExchangeNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExchangeNode",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v57/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BulkOrderViewQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "bulkOrders",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "BulkOrderNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BulkOrderNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BulkOrderNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "portfolioorderSet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioOrderNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfolioOrderNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfolioOrderNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v11/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "tradeInvoice",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TradeInvoiceNode",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v18/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v19/*: any*/),
                                      (v2/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "stockOrders",
                                    "storageKey": "stockOrders(orderBy:\"createdAt\")",
                                    "args": (v20/*: any*/),
                                    "concreteType": "StockOrderNodeConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "StockOrderNodeEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "StockOrderNode",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "parentOrder",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "OrderNode",
                                                "plural": false,
                                                "selections": (v10/*: any*/)
                                              },
                                              (v2/*: any*/),
                                              (v49/*: any*/),
                                              (v9/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "pendingStatus",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v21/*: any*/),
                                              (v22/*: any*/),
                                              (v42/*: any*/),
                                              (v6/*: any*/),
                                              (v7/*: any*/),
                                              (v8/*: any*/),
                                              (v28/*: any*/),
                                              (v23/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "executedQuantityToDate",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "matched",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "blockedHoldings",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "blockedProceeds",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "blockedBaseCharges",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "blockedLocalCharges",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "customCommission",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "advancedOrderType",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "actionLogs",
                                                "storageKey": "actionLogs(orderBy:\"actionTime\")",
                                                "args": [
                                                  {
                                                    "kind": "Literal",
                                                    "name": "orderBy",
                                                    "value": "actionTime"
                                                  }
                                                ],
                                                "concreteType": "ActionLogUserRequestNodeConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ActionLogUserRequestNodeEdge",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "node",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "ActionLogUserRequestNode",
                                                        "plural": false,
                                                        "selections": [
                                                          (v58/*: any*/),
                                                          (v59/*: any*/),
                                                          (v60/*: any*/),
                                                          (v61/*: any*/),
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "user",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "UserNode",
                                                            "plural": false,
                                                            "selections": (v62/*: any*/)
                                                          },
                                                          (v2/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "contract",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ContractNode",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v24/*: any*/),
                                                  (v25/*: any*/),
                                                  (v13/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "industry",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  (v26/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "instrumentType",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "exchange",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ExchangeNode",
                                                    "plural": false,
                                                    "selections": [
                                                      (v13/*: any*/),
                                                      (v25/*: any*/),
                                                      (v2/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "account",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "AccountNode",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v13/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "clientaccount",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ClientAccountNode",
                                                    "plural": false,
                                                    "selections": [
                                                      (v2/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "accountType",
                                                        "args": null,
                                                        "storageKey": null
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v63/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "executionSet",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ExecutionNodeConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ExecutionNodeEdge",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "node",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "ExecutionNode",
                                                        "plural": false,
                                                        "selections": [
                                                          (v29/*: any*/),
                                                          (v21/*: any*/),
                                                          (v30/*: any*/),
                                                          (v31/*: any*/),
                                                          (v22/*: any*/),
                                                          (v24/*: any*/),
                                                          (v2/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "proceedsToDate",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "proceedsToDateBase",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "brokerOrder",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "BrokerOrderNode",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v40/*: any*/),
                                                  (v41/*: any*/),
                                                  (v42/*: any*/),
                                                  (v43/*: any*/),
                                                  (v44/*: any*/),
                                                  (v45/*: any*/),
                                                  (v46/*: any*/),
                                                  (v47/*: any*/),
                                                  (v48/*: any*/),
                                                  (v9/*: any*/),
                                                  (v49/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "ackedClientOrderId",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "brokerSideOrderId",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  (v50/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "algoParams",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "OrderAlgoParamsNode",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "algo",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "orderalgoparamstwap",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "OrderAlgoParamsTWAPNode",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "strategyType",
                                                            "args": null,
                                                            "storageKey": null
                                                          },
                                                          (v55/*: any*/),
                                                          (v56/*: any*/),
                                                          (v64/*: any*/),
                                                          (v2/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "orderalgoparamsvwap",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "OrderAlgoParamsVWAPNode",
                                                        "plural": false,
                                                        "selections": [
                                                          (v2/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "maxVolumeRatio",
                                                            "args": null,
                                                            "storageKey": null
                                                          },
                                                          (v55/*: any*/),
                                                          (v56/*: any*/),
                                                          (v64/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "neverTakeLiquidity",
                                                            "args": null,
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "speedup",
                                                            "args": null,
                                                            "storageKey": null
                                                          }
                                                        ]
                                                      },
                                                      (v2/*: any*/)
                                                    ]
                                                  },
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "brokerorderamendmentSet",
                                                    "storageKey": "brokerorderamendmentSet(orderBy:\"sequence\")",
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "orderBy",
                                                        "value": "sequence"
                                                      }
                                                    ],
                                                    "concreteType": "BrokerOrderAmendmentNodeConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "edges",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "BrokerOrderAmendmentNodeEdge",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "BrokerOrderAmendmentNode",
                                                            "plural": false,
                                                            "selections": [
                                                              (v2/*: any*/),
                                                              (v53/*: any*/),
                                                              (v52/*: any*/),
                                                              (v22/*: any*/),
                                                              (v51/*: any*/),
                                                              (v9/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "alias": null,
                                                                "name": "blockingRevised",
                                                                "args": null,
                                                                "storageKey": null
                                                              },
                                                              (v7/*: any*/),
                                                              (v8/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "orderPtr",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "OrderNode",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "orderapprovalcontractSet",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "OrderApprovalContractNodeConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "edges",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "OrderApprovalContractNodeEdge",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "OrderApprovalContractNode",
                                                            "plural": false,
                                                            "selections": [
                                                              (v2/*: any*/),
                                                              {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "approval",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "OrderApprovalNode",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v2/*: any*/),
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "portfolioOrder",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "PortfolioOrderNode",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v2/*: any*/),
                                                                      (v9/*: any*/)
                                                                    ]
                                                                  },
                                                                  (v7/*: any*/),
                                                                  (v8/*: any*/),
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "approvedAt",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "notifiedAt",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "remindedAt",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "proposal",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "OrderProposalNode",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v2/*: any*/),
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "alias": null,
                                                                        "name": "type",
                                                                        "args": null,
                                                                        "storageKey": null
                                                                      }
                                                                    ]
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "rationaleUrl",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "approvedBy",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "UserNode",
                                                                    "plural": false,
                                                                    "selections": (v62/*: any*/)
                                                                  },
                                                                  (v9/*: any*/),
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "portfolio",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "PortfolioNode",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v2/*: any*/),
                                                                      (v12/*: any*/),
                                                                      {
                                                                        "kind": "LinkedField",
                                                                        "alias": null,
                                                                        "name": "account",
                                                                        "storageKey": null,
                                                                        "args": null,
                                                                        "concreteType": "AccountNode",
                                                                        "plural": false,
                                                                        "selections": (v37/*: any*/)
                                                                      }
                                                                    ]
                                                                  },
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "actionLogs",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ActionLogUserRequestNodeConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "LinkedField",
                                                                        "alias": null,
                                                                        "name": "edges",
                                                                        "storageKey": null,
                                                                        "args": null,
                                                                        "concreteType": "ActionLogUserRequestNodeEdge",
                                                                        "plural": true,
                                                                        "selections": [
                                                                          {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "node",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "ActionLogUserRequestNode",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v2/*: any*/),
                                                                              (v61/*: any*/),
                                                                              (v58/*: any*/),
                                                                              (v60/*: any*/),
                                                                              (v59/*: any*/),
                                                                              {
                                                                                "kind": "LinkedField",
                                                                                "alias": null,
                                                                                "name": "user",
                                                                                "storageKey": null,
                                                                                "args": null,
                                                                                "concreteType": "UserNode",
                                                                                "plural": false,
                                                                                "selections": (v4/*: any*/)
                                                                              }
                                                                            ]
                                                                          }
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v2/*: any*/)
                                                ]
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "tradeInvoice",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "TradeInvoiceNode",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v18/*: any*/),
                                                  (v17/*: any*/),
                                                  (v19/*: any*/),
                                                  (v7/*: any*/),
                                                  (v8/*: any*/),
                                                  (v63/*: any*/)
                                                ]
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "transactions",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "TransactionNodeConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "TransactionNodeEdge",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "node",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "TransactionNode",
                                                        "plural": false,
                                                        "selections": [
                                                          (v2/*: any*/),
                                                          (v33/*: any*/),
                                                          (v34/*: any*/),
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "transactionaccountchargeSet",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "TransactionAccountChargeNodeConnection",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "edges",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "TransactionAccountChargeNodeEdge",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "node",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "TransactionAccountChargeNode",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v2/*: any*/),
                                                                      (v35/*: any*/),
                                                                      (v24/*: any*/),
                                                                      (v36/*: any*/),
                                                                      {
                                                                        "kind": "LinkedField",
                                                                        "alias": null,
                                                                        "name": "accountchargePtr",
                                                                        "storageKey": null,
                                                                        "args": null,
                                                                        "concreteType": "AccountChargeNode",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v38/*: any*/),
                                                                          (v2/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "fxorderSet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FxOrderNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FxOrderNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FxOrderNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v23/*: any*/),
                                  (v27/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "orderPtr",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderNode",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v28/*: any*/),
                                      (v32/*: any*/),
                                      (v39/*: any*/),
                                      (v2/*: any*/)
                                    ]
                                  },
                                  (v54/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "exchanges",
            "storageKey": null,
            "args": null,
            "concreteType": "ExchangeNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ExchangeNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExchangeNode",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v57/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "BulkOrderViewQuery",
    "id": null,
    "text": "query BulkOrderViewQuery(\n  $bulkOrderId: ID!\n) {\n  viewer {\n    bulkOrders(id: $bulkOrderId) {\n      edges {\n        node {\n          id\n          createdBy {\n            id\n            fullName\n          }\n          portfolioorderSet {\n            edges {\n              node {\n                id\n                side\n                createdAt\n                updatedAt\n                status\n                bulkOrder {\n                  id\n                }\n                portfolio {\n                  id\n                  trackingVueName\n                  trackingVue {\n                    id\n                    name\n                  }\n                }\n                account {\n                  id\n                  name\n                }\n                tradeInvoice {\n                  pdf\n                  pdfUrl\n                  createdAt\n                  updatedAt\n                  state\n                  id\n                }\n                stockOrders(orderBy: \"createdAt\") {\n                  edges {\n                    node {\n                      ...StockOrderDetails_stockOrder\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n          fxorderSet {\n            edges {\n              node {\n                id\n                price\n                quantity\n                createdAt\n                updatedAt\n                quantityToDate\n                contract {\n                  id\n                  currency\n                  symbol\n                  localSymbol\n                  ibConId\n                }\n                orderPtr {\n                  account {\n                    id\n                    name\n                  }\n                  orderType\n                  executionSet {\n                    edges {\n                      node {\n                        id\n                        transaction {\n                          id\n                        }\n                        price\n                        proceeds\n                        executionDatetime\n                        quantity\n                        currency\n                      }\n                    }\n                  }\n                  transactions {\n                    edges {\n                      node {\n                        id\n                        commission\n                        tax\n                        transactionaccountchargeSet {\n                          edges {\n                            node {\n                              id\n                              amount\n                              currency\n                              feeType\n                              accountchargePtr {\n                                id\n                                amount\n                                currency\n                                accountchargetenantportionSet {\n                                  edges {\n                                    node {\n                                      id\n                                      quantity\n                                      tenant {\n                                        name\n                                        id\n                                      }\n                                    }\n                                  }\n                                }\n                              }\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                  id\n                }\n                brokerOrder {\n                  id\n                  twsOrderId\n                  twsPermId\n                  cashQuantity\n                  quantityFilled\n                  quantityLeft\n                  stopPrice\n                  trailStopRatio\n                  trailStopOffset\n                  lastSyncTime\n                  status\n                  orderRef\n                  side\n                  orderType\n                  ibExchange {\n                    id\n                    symbol\n                  }\n                  brokerorderamendmentSet {\n                    edges {\n                      node {\n                        id\n                        quantity\n                        previousQuantity\n                        previousLimitPrice\n                        limitPrice\n                        amendmentRef\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    exchanges {\n      edges {\n        node {\n          symbol\n          nextDaySession {\n            startTime\n            endTime\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment StockOrderDetails_stockOrder on StockOrderNode {\n  parentOrder {\n    id\n  }\n  id\n  orderRef\n  status\n  pendingStatus\n  price\n  quantity\n  cashQuantity\n  side\n  createdAt\n  updatedAt\n  orderType\n  quantityToDate\n  executedQuantityToDate\n  matched\n  blockedHoldings\n  blockedProceeds\n  blockedBaseCharges\n  blockedLocalCharges\n  customCommission\n  advancedOrderType\n  actionLogs(orderBy: \"actionTime\") {\n    edges {\n      node {\n        actionId\n        actionType\n        actionTime\n        actionDescription\n        user {\n          fullName\n          id\n        }\n        id\n      }\n    }\n  }\n  contract {\n    id\n    currency\n    symbol\n    name\n    industry\n    ibConId\n    instrumentType\n    exchange {\n      name\n      symbol\n      id\n    }\n  }\n  account {\n    id\n    name\n    clientaccount {\n      id\n      accountType\n    }\n  }\n  portfolioOrder {\n    id\n  }\n  executionSet {\n    edges {\n      node {\n        transaction {\n          id\n        }\n        price\n        proceeds\n        executionDatetime\n        quantity\n        currency\n        id\n      }\n    }\n  }\n  proceedsToDate\n  proceedsToDateBase\n  brokerOrder {\n    id\n    twsOrderId\n    twsPermId\n    cashQuantity\n    quantityFilled\n    quantityLeft\n    stopPrice\n    trailStopRatio\n    trailStopOffset\n    lastSyncTime\n    status\n    orderRef\n    ackedClientOrderId\n    brokerSideOrderId\n    ibExchange {\n      id\n      symbol\n    }\n    algoParams {\n      algo\n      orderalgoparamstwap {\n        strategyType\n        startTime\n        endTime\n        allowPastEndTime\n        id\n      }\n      orderalgoparamsvwap {\n        id\n        maxVolumeRatio\n        startTime\n        endTime\n        allowPastEndTime\n        neverTakeLiquidity\n        speedup\n      }\n      id\n    }\n    brokerorderamendmentSet(orderBy: \"sequence\") {\n      edges {\n        node {\n          id\n          limitPrice\n          previousLimitPrice\n          quantity\n          previousQuantity\n          status\n          blockingRevised\n          createdAt\n          updatedAt\n        }\n      }\n    }\n  }\n  orderPtr {\n    orderapprovalcontractSet {\n      edges {\n        node {\n          id\n          approval {\n            id\n            portfolioOrder {\n              id\n              status\n            }\n            createdAt\n            updatedAt\n            approvedAt\n            notifiedAt\n            remindedAt\n            proposal {\n              id\n              type\n            }\n            rationaleUrl\n            approvedBy {\n              fullName\n              id\n            }\n            status\n            portfolio {\n              id\n              trackingVueName\n              account {\n                name\n                id\n              }\n            }\n            actionLogs {\n              edges {\n                node {\n                  id\n                  actionDescription\n                  actionId\n                  actionTime\n                  actionType\n                  user {\n                    id\n                    fullName\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  tradeInvoice {\n    id\n    pdfUrl\n    pdf\n    state\n    createdAt\n    updatedAt\n    portfolioOrder {\n      id\n    }\n  }\n  transactions {\n    edges {\n      node {\n        id\n        commission\n        tax\n        transactionaccountchargeSet {\n          edges {\n            node {\n              id\n              amount\n              currency\n              feeType\n              accountchargePtr {\n                accountchargetenantportionSet {\n                  edges {\n                    node {\n                      id\n                      quantity\n                      tenant {\n                        name\n                        id\n                      }\n                    }\n                  }\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '25dec909c6aa2df589b0514c512a12a8';
module.exports = node;
